/* PP ENGRAVE PREVIEW

   Draws the customer's engraving onto a photograph of the clasp, in the
   chosen font and layout, as they type. It replaces the Photoshop mockup the
   team used to build by hand and email out for approval.

   HOW IT IS WIRED. pp-engraving.js owns the field, the cleaning rules and
   the add to cart block. After every repaint it fires a ppdh:engrave event
   on the field's wrapper carrying { kind, font, value, ok }. This file only
   listens to that event and to the Select Metal picker. It never edits the
   field and never touches the button, so it cannot break the order capture
   if it fails: the worst case is a picture that does not update.

   EVERYTHING IS DRAWN IN THE PHOTO'S OWN COORDINATES. The image is placed
   at the original 1433 x 1098 size (the viewBox crops in a little), and the
   face centre and size for
   each clasp shape are measured on that photo (FACE below). The JPGs served
   are smaller, but the viewBox keeps the geometry independent of that, so a
   re-shot photo only needs FACE re-measured.

   SIZING IS FIT-TO-BOX, NOT FIXED POINT SIZES. Each layout has a target
   height and a maximum width as fractions of the face. The text is set at a
   reference size, measured, and scaled to whichever limit binds first, then
   re-centred on its measured box. That keeps a wide W or a long script date
   inside the face without per-letter tables.

   THE MONOGRAM IS ARRANGED HERE, not in the field. The customer types first,
   middle, last. The preview draws first, LAST, middle, with the surname
   initial larger in the centre, which is how it will be engraved. This is
   the one style where the picture is doing work the text field cannot.

   THE ENGRAVED LOOK is a single flat fill in a dark grey, slightly see
   through so the polish of the metal shows. That matches how the team's
   mockups show engraving. An earlier bevelled version, with light and dark
   offset copies, read as messy at this size and was dropped.

   THE LETTERS LINE IS HIDDEN WHILE THIS RUNS. Once the picture is drawing,
   the wrapper gets has-ppep and the CSS hides the Letters to be engraved
   line, since the two say the same thing. If this script fails, the class
   is never added and the text line still shows.

   FONTS. Classic asks for the system Times New Roman first and falls back
   to an embedded metric-compatible serif, so Windows, Mac and iOS show the
   real face and Android shows a near twin. Script is always the embedded
   Zapf Chancery-style face, since ZapfChan MdIt BT is not on customer
   devices. Drawing waits on document.fonts so the first frame is not set in
   a fallback and then jump. */

(function () {
  var fig = document.querySelector('[data-ppep]');
  if (!fig) return;

  var NS = 'http://www.w3.org/2000/svg';
  var svg  = fig.querySelector('svg');
  var img  = fig.querySelector('[data-ppep-img]');
  var layer = fig.querySelector('[data-ppep-text]');
  var shape = fig.getAttribute('data-shape') === 'square' ? 'square' : 'round';
  var srcs = {
    yg: fig.getAttribute('data-src-yg'),
    wg: fig.getAttribute('data-src-wg')
  };

  /* Face geometry, in photo pixels. cx, cy = centre; w, h = usable face. */
  var FACE = {
    round:  { cx: 735, cy: 592, w: 640, h: 640 },
    square: { cx: 732, cy: 585, w: 590, h: 590 }
  };

  /* Per layout: target cap height and max width, as fractions of the face. */
  var LAYOUT = {
    single:   { cap: 0.50, maxW: 0.60 },
    three:    { cap: 0.25, maxW: 0.72 },
    date:     { cap: 0.15, maxW: 0.78 },
    monoSide: { cap: 0.24 },
    monoMid:  { cap: 0.40 },
    monoMaxW: 0.80
  };

  var FAMILY = {
    classic: '"Times New Roman", "PP Engrave Classic", Times, serif',
    script:  '"PP Engrave Script", "Zapf Chancery", cursive'
  };
  var CAP = { classic: 0.662, script: 0.60 };

  var TONE = {
    yg: '#5a4515',
    wg: '#3f4146'
  };

  var SAMPLE = { single: 'A', three: 'ABC', monogram: 'ABC', date: '10.10.26' };

  var state = { kind: 'single', font: 'classic', value: '', metal: 'wg' };

  /* ---- metal picker ---- */
  var root = document.querySelector('[data-ppdh]');
  var metalGroup = null;
  var groups = root ? root.querySelectorAll('[data-ppdh-opt]') : [];
  for (var i = 0; i < groups.length; i++) {
    if (groups[i].getAttribute('data-ppdh-optname') === 'Select Metal') {
      metalGroup = groups[i];
      break;
    }
  }

  function readMetal() {
    var name = '';
    if (metalGroup) {
      var on = metalGroup.querySelector('[aria-pressed="true"]');
      if (on) name = on.getAttribute('data-ppdh-val') || '';
    }
    if (!name) name = fig.getAttribute('data-metal') || '';
    return /yellow/i.test(name) ? 'yg' : 'wg';
  }

  /* ---- drawing ---- */
  function el(name, attrs, text) {
    var n = document.createElementNS(NS, name);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (text != null) n.textContent = text;
    return n;
  }

  /* Set one run of text, fitted to cap height and max width, centred on
     (cx, cy). Returns the group so callers can position it further. */
  function run(parent, str, font, capPx, maxW, cx, cy) {
    var g = el('g', {});
    var t = el('text', {
      x: 0, y: 0,
      'font-family': FAMILY[font],
      'font-size': 100,
      'text-anchor': 'middle'
    }, str);
    g.appendChild(t);
    parent.appendChild(g);

    var size = capPx / CAP[font];
    var b = t.getBBox();
    if (b.width > 0 && maxW && (b.width * size / 100) > maxW) {
      size = maxW * 100 / b.width;
    }
    t.setAttribute('font-size', size.toFixed(1));
    b = t.getBBox();

    /* centre the measured box, but use the cap band for vertical centring
       so a script descender does not shove the line upward */
    var capTop = -size * CAP[font];
    var dy = cy - (capTop / 2);
    var dx = cx - (b.x + b.width / 2);
    g.setAttribute('transform', 'translate(' + dx.toFixed(1) + ',' + dy.toFixed(1) + ')');
    return { g: g, t: t, size: size, width: b.width };
  }

  function engrave(textNode) {
    textNode.setAttribute('fill', TONE[state.metal]);
    textNode.setAttribute('fill-opacity', '.78');
  }

  function draw() {
    var f = FACE[shape];
    var ghost = !state.value;
    var v = ghost ? SAMPLE[state.kind] : state.value;
    var font = state.font;

    while (layer.firstChild) layer.removeChild(layer.firstChild);
    layer.setAttribute('opacity', ghost ? '.28' : '1');

    var made = [];

    if (state.kind === 'monogram' && v.length === 3) {
      /* typed first, middle, last; engraved first, LAST, middle */
      var sideCap = f.h * LAYOUT.monoSide.cap;
      var midCap  = f.h * LAYOUT.monoMid.cap;
      var gap = f.w * 0.012;
      var L = run(layer, v.charAt(0), font, sideCap, null, 0, f.cy);
      var M = run(layer, v.charAt(2), font, midCap,  null, 0, f.cy);
      var R = run(layer, v.charAt(1), font, sideCap, null, 0, f.cy);
      var wL = L.width, wM = M.width, wR = R.width;
      var total = wL + wM + wR + gap * 2;
      var scale = Math.min(1, (f.w * LAYOUT.monoMaxW) / total);
      if (scale < 1) {
        while (layer.firstChild) layer.removeChild(layer.firstChild);
        L = run(layer, v.charAt(0), font, sideCap * scale, null, 0, f.cy);
        M = run(layer, v.charAt(2), font, midCap * scale,  null, 0, f.cy);
        R = run(layer, v.charAt(1), font, sideCap * scale, null, 0, f.cy);
        wL = L.width; wM = M.width; wR = R.width; gap *= scale;
        total = wL + wM + wR + gap * 2;
      }
      var left = f.cx - total / 2;
      place(L, left + wL / 2, f.cy, font);
      place(M, left + wL + gap + wM / 2, f.cy, font);
      place(R, left + wL + gap + wM + gap + wR / 2, f.cy, font);
      made = [L, M, R];
    } else {
      var lay = state.kind === 'date' ? LAYOUT.date
              : state.kind === 'single' ? LAYOUT.single
              : LAYOUT.three;
      made = [run(layer, v, font, f.h * lay.cap, f.w * lay.maxW, f.cx, f.cy)];
    }

    for (var i = 0; i < made.length; i++) engrave(made[i].t);
  }

  function place(r, cx, cy, font) {
    var b = r.t.getBBox();
    var capTop = -r.size * CAP[font];
    var dx = cx - (b.x + b.width / 2);
    var dy = cy - capTop / 2;
    r.g.setAttribute('transform', 'translate(' + dx.toFixed(1) + ',' + dy.toFixed(1) + ')');
  }

  function setMetal() {
    var m = readMetal();
    if (m !== state.metal || !img.getAttribute('href')) {
      state.metal = m;
      if (srcs[m]) img.setAttribute('href', srcs[m]);
      fig.setAttribute('data-metal-on', m);
    }
  }

  function redraw() {
    setMetal();
    try { draw(); } catch (e) { /* a failed preview must never matter */ }
  }

  /* ---- events ---- */
  var box = document.querySelector('[data-ppdh-engrave]');
  if (box) {
    box.addEventListener('ppdh:engrave', function (e) {
      var d = e.detail || {};
      state.kind = d.kind || 'single';
      state.font = d.font === 'script' ? 'script' : 'classic';
      state.value = d.value || '';
      redraw();
    });
  }

  if (metalGroup) {
    if (window.MutationObserver) {
      new MutationObserver(redraw).observe(metalGroup, {
        subtree: true, attributes: true, attributeFilter: ['aria-pressed']
      });
    }
    metalGroup.addEventListener('click', function () { setTimeout(redraw, 0); });
  }

  fig.hidden = false;
  if (box) box.classList.add('has-ppep');
  setMetal();
  var go = function () { redraw(); };
  if (document.fonts && document.fonts.load) {
    Promise.all([
      document.fonts.load('100px "PP Engrave Script"', 'ABC'),
      document.fonts.load('100px "PP Engrave Classic"', 'ABC')
    ]).then(go, go);
  } else {
    go();
  }
  /* the event from pp-engraving.js may already have fired before this ran */
  if (box && box.__ppdhLast) {
    var d0 = box.__ppdhLast;
    state.kind = d0.kind; state.font = d0.font; state.value = d0.value || '';
  }
  go();
})();
